<template>
  <transition name="brand-panel-dropdown">
    <div v-if="show" class="place-panel" @click.stop>
      <div class="panel-header">
        <h4 class="panel-title">产地筛选</h4>
        <div class="selected-info" v-if="placeValue.length > 0">已选 {{ placeValue.length }} 个</div>
      </div>

      <div class="panel-content">
        <div class="search-box" v-if="placeList.length > 8">
          <el-input
            v-model="searchKeyword"
            placeholder="搜索产地..."
            size="small"
            prefix-icon="el-icon-search"
            clearable
            @input="handleSearch"
          ></el-input>
        </div>

        <div class="place-list-container">
          <div v-if="filteredPlaceList.length === 0" class="empty-state">
            <i class="el-icon-location-outline"></i>
            <p>未找到相关产地</p>
          </div>

          <div class="place-grid" v-else>
            <div
              :class="{
                'place-item': true,
                active: placeValue.includes(item)
              }"
              v-for="item in filteredPlaceList"
              :key="item"
              @click="choosePlace(item)"
            >
              <span class="place-name">{{ item }}</span>
              <div class="check-icon" v-if="placeValue.includes(item)">
                <i class="el-icon-check"></i>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="panel-footer">
        <div class="selected-tags" v-if="placeValue.length > 0">
          <div class="selected-tags-container">
            <span v-for="place in placeValue" :key="place" class="selected-tag" @click="removePlace(place)">
              {{ place }}
              <i class="el-icon-close"></i>
            </span>
          </div>
        </div>

        <div class="action-buttons">
          <el-button size="small" class="btn-cancel" @click.stop="cancel">
            取消
          </el-button>
          <el-button size="small" class="btn-reset" @click.stop="reset" :disabled="placeValue.length === 0">
            重置
          </el-button>
          <el-button type="primary" size="small" class="btn-confirm" @click.stop="confirm">
            确定
          </el-button>
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
export default {
  data() {
    return {
      show: false,
      placeList: [],
      placeValue: [],
      searchKeyword: "",
      filteredPlaceList: []
    };
  },
  methods: {
    reset() {
      this.placeValue = [];
      this.searchKeyword = "";
      this.filteredPlaceList = [...this.placeList];
    },

    open(list, placeValue) {
      this.show = true;
      this.placeList = list;
      this.placeValue = JSON.parse(JSON.stringify(placeValue));
      this.filteredPlaceList = [...list];

      // 点击外部关闭
      setTimeout(() => {
        document.addEventListener("click", this.handleClickOutside);
      }, 0);
    },

    handleSearch() {
      if (!this.searchKeyword) {
        this.filteredPlaceList = [...this.placeList];
        return;
      }

      const keyword = this.searchKeyword.toLowerCase();
      this.filteredPlaceList = this.placeList.filter(place => place.toLowerCase().includes(keyword));
    },

    choosePlace(item) {
      if (this.placeValue.includes(item)) {
        this.removePlace(item);
      } else {
        this.placeValue.push(item);
      }
    },

    removePlace(place) {
      const index = this.placeValue.findIndex(e => e === place);
      if (index > -1) {
        this.placeValue.splice(index, 1);
      }
    },

    handleClickOutside(event) {
      if (!this.$el?.contains(event.target)) {
        this.cancel();
      }
    },

    cancel() {
      document.removeEventListener("click", this.handleClickOutside);
      this.show = false;
      this.searchKeyword = "";
      setTimeout(() => {
        this.filteredPlaceList = [];
      }, 300);
      this.$emit("close");
    },

    confirm() {
      document.removeEventListener("click", this.handleClickOutside);
      this.$emit("change", this.placeValue);
      this.cancel();
    }
  }
};
</script>

<style lang="scss" scoped>
.place-panel {
  position: absolute;
  top: calc(100% - 12px);
  left: 0;
  right: 0;
  background: white;
  border: 1px solid #e4e7ed;
  border-top: none;
  border-radius: 0 0 8px 8px;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.12);
  z-index: 1000;
  max-height: 400px;
  display: flex;
  flex-direction: column;
  overflow: hidden;
}

.panel-header {
  padding: 12px 16px;
  border-bottom: 1px solid #f0f0f0;
  background: #fafafa;
  display: flex;
  align-items: center;
  justify-content: space-between;

  .panel-title {
    margin: 0;
    font-size: 14px;
    font-weight: 600;
    color: #333;
  }

  .selected-info {
    font-size: 12px;
    color: var(--color-primary);
    background: #ecf5ff;
    padding: 2px 8px;
    border-radius: 10px;
  }
}

.panel-content {
  flex: 1;
  padding: 12px 16px;
  overflow-y: auto;
  max-height: 280px;

  .search-box {
    margin-bottom: 12px;

    ::v-deep .el-input__inner {
      border-radius: 6px;
      font-size: 12px;
    }
  }

  .empty-state {
    text-align: center;
    padding: 20px;
    color: #909399;

    i {
      font-size: 24px;
      margin-bottom: 8px;
      opacity: 0.5;
    }

    p {
      margin: 0;
      font-size: 12px;
    }
  }
}

.place-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(100px, 1fr));
  gap: 8px;
}

.place-item {
  position: relative;
  background: #f8f9fa;
  border: 1px solid #e4e7ed;
  border-radius: 6px;
  padding: 8px;
  cursor: pointer;
  transition: all 0.2s ease;
  display: flex;
  align-items: center;
  justify-content: space-between;
  min-height: 32px;

  &:hover {
    border-color: var(--color-primary);
    background: #f0f7ff;
    transform: translateY(-1px);
  }

  &.active {
    background: linear-gradient(135deg, #ecf5ff 0%, #d9ecff 100%);
    border-color: var(--color-primary);

    .place-name {
      color: var(--color-primary);
      font-weight: 600;
    }
  }

  .place-name {
    font-size: 12px;
    color: #333;
    font-weight: 500;
    flex: 1;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }

  .check-icon {
    color: var(--color-primary);
    font-size: 12px;
    font-weight: bold;
    margin-left: 4px;
    flex-shrink: 0;
  }
}

.panel-footer {
  padding: 12px 16px;
  border-top: 1px solid #f0f0f0;
  background: #fafafa;

  .selected-tags {
    margin-bottom: 12px;

    .selected-tags-container {
      display: flex;
      flex-wrap: wrap;
      gap: 6px;
      max-height: 60px;
      overflow-y: auto;
    }

    .selected-tag {
      background: linear-gradient(135deg, var(--color-primary) 0%, #66b1ff 100%);
      color: white;
      padding: 2px 8px;
      border-radius: 12px;
      font-size: 11px;
      display: flex;
      align-items: center;
      gap: 4px;
      cursor: pointer;
      transition: all 0.2s;
      line-height: 1.2;

      &:hover {
        background: linear-gradient(135deg, #f56c6c 0%, #f78989 100%);
        transform: scale(1.05);
      }

      i {
        font-size: 10px;
        margin-left: 2px;
      }
    }
  }

  .action-buttons {
    display: flex;
    justify-content: flex-end;
    gap: 8px;

    .btn-cancel {
      border-color: #dcdfe6;
      font-size: 12px;
      padding: 6px 12px;

      &:hover {
        border-color: #c0c4cc;
        background-color: #f5f7fa;
      }
    }

    .btn-reset {
      color: #f56c6c;
      border-color: #f56c6c;
      font-size: 12px;
      padding: 6px 12px;

      &:hover {
        background-color: #fef0f0;
        border-color: #f78989;
      }

      &:disabled {
        color: #c0c4cc;
        border-color: #e4e7ed;
        background-color: #f5f7fa;
      }
    }

    .btn-confirm {
      background: linear-gradient(135deg, var(--color-primary) 0%, #66b1ff 100%);
      border: none;
      font-size: 12px;
      padding: 6px 16px;

      &:hover {
        background: linear-gradient(135deg, #66b1ff 0%, var(--color-primary) 100%);
        transform: translateY(-1px);
        box-shadow: 0 2px 6px rgba(64, 158, 255, 0.3);
      }

      &:disabled {
        background: #c0c4cc;
        transform: none;
        box-shadow: none;
      }
    }
  }
}

// 下拉动画
.brand-panel-dropdown-enter-active {
  animation: brand-panel-dropdown-in 0.2s ease-out;
}

.brand-panel-dropdown-leave-active {
  animation: brand-panel-dropdown-out 0.15s ease-in;
}

@keyframes brand-panel-dropdown-in {
  0% {
    opacity: 0;
    transform: translateY(-10px) scale(0.95);
  }
  100% {
    opacity: 1;
    transform: translateY(0) scale(1);
  }
}

@keyframes brand-panel-dropdown-out {
  0% {
    opacity: 1;
    transform: translateY(0) scale(1);
  }
  100% {
    opacity: 0;
    transform: translateY(-10px) scale(0.95);
  }
}

// 滚动条样式
.place-panel ::-webkit-scrollbar {
  width: 4px;
}

.place-panel ::-webkit-scrollbar-track {
  background: #f1f1f1;
  border-radius: 2px;
}

.place-panel ::-webkit-scrollbar-thumb {
  background: #c1c1c1;
  border-radius: 2px;
}

.place-panel ::-webkit-scrollbar-thumb:hover {
  background: #a8a8a8;
}

// 响应式设计
@media (max-width: 768px) {
  .place-panel {
    max-height: 350px;
  }

  .place-grid {
    grid-template-columns: repeat(auto-fill, minmax(80px, 1fr));
    gap: 6px;
  }

  .panel-header,
  .panel-content,
  .panel-footer {
    padding: 10px 12px;
  }

  .action-buttons {
    flex-wrap: wrap;

    .el-button {
      flex: 1;
      min-width: 60px;
    }
  }
}
</style>
